import { css } from 'emotion'
import { LINK_HIGHLIGHT_COLOR, LINK_COLOR } from 'constants/styleConstants'

export const MentionLinkStyles = css`
  background-color: ${LINK_HIGHLIGHT_COLOR};
  color: ${LINK_COLOR};
  display: inline-box;
`
